package music.jammers.client.shared.event.domain.usecase

import music.jammers.client.shared.event.domain.model.ValidationError
import music.jammers.client.shared.event.domain.model.ValidationErrorValue
import music.jammers.client.shared.event.domain.validator.EventFieldValidator
import music.jammers.shared.event.domain.model.CardInfo
import music.jammers.shared.event.domain.model.EventData

class ValidateEventUseCase(
    private val eventFieldValidator: EventFieldValidator,
) {

    operator fun invoke(eventDataModel: EventData): List<ValidationError> {
        val errors = mutableListOf<ValidationError?>()

        with(eventDataModel) {
            errors.add(eventFieldValidator.validate(TITLE, title))
            errors.add(eventFieldValidator.validate(DESCRIPTION, description))
            errors.add(eventFieldValidator.validate(DATE, date.toString()))
            errors.add(eventFieldValidator.validate(GENRE, genre))
            errors.add(eventFieldValidator.validate(SPOT, spot))
            errors.add(eventFieldValidator.validate(SONGS_COUNT, songsCount.toString()))
            errors.add(eventFieldValidator.validate(APPLIES_PER_PERSON, appliesPerPerson.toString()))

            if (selectedInstrumentList.isEmpty()) {
                errors.add(ValidationError(SELECTED_INSTRUMENTS, ValidationErrorValue.ItemNotSelected))
            }

            if (cardInfo == CardInfo.INVALID) {
                errors.add(ValidationError(CARD_INFO, ValidationErrorValue.EmptyValue))
            }
        }

        return errors.filterNotNull()
    }

    companion object Fields {

        const val TITLE = "title"
        const val DESCRIPTION = "description"
        const val CARD_INFO = "cardInfo"
        const val DATE = "date"
        const val GENRE = "genre"
        const val SPOT = "spot"
        const val SONGS_COUNT = "songsCount"
        const val APPLIES_PER_PERSON = "appliesPerPerson"
        const val SELECTED_INSTRUMENTS = "selectedInstruments"
        const val SONG_LIMIT = 100
        const val APPLIES_LIMIT = 50
        const val TEXT_LENGTH_LIMIT = 50
    }
}